<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="$options.titleText"
    :action="onSubmit"
    :success-text="$options.successText"
    disable-success-notification
  >
    <v-overlay :value="isLoading" absolute color="white">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </v-overlay>

    <template v-if="!successMessage">
      <div class="font-italic">
        <p>
          Чтобы скопировать информацию из прошедшего мероприятия и открыть его
          на доработку, выберите нужное мероприятие в выпадающем списке ниже.
          Будет скопирован шаблон формы, участники и данные, которые ими были
          внесены, эксперты, данные из проведенных ранее экспертиз и кураторы.
        </p>
      </div>

      <v-autocomplete
        v-model="selected"
        label="МунМех"
        :items="list"
        :loading="isLoading"
        outlined
        dense
        item-value="id"
        item-text="name"
      />

      <div class="font-italic">
        <p>
          Чтобы внести изменения в скопированный шаблон формы или создать
          абсолютно новый шаблон, загрузите в поле ниже обновленную форму
          шаблона в формате csv. Если вы ничего не копировали, то будет создан
          пустой шаблон формы мероприятия. Участников, экспертов и кураторов
          будет необходимо добавить отдельно. Если вы копировали предыдущее
          мероприятие, то шаблон формы будет приведен к новому формату,
          участники, эксперты и кураторы сохранятся. Данные каждого участника и
          информация из проведенных ранее экспертиз будет сохранена только при
          полном совпадении названия показателей в старом и новом шаблоне.
          Остальные данные будут удалены.
        </p>
      </div>

      <v-file-input v-model="oFile" label="CSV файл" dense outlined />

      <div class="ml-1 mb-2">
        <a
          v-if="fileTemplateUrl"
          :href="fileTemplateUrl"
          target="_blank"
        >Скачать пример формы шаблона</a>
      </div>
    </template>

    <div v-if="successMessage" v-html="successMessage" />

    <div
      v-else-if="errorMessage"
      class="error--text ml-8"
      v-text="errorMessage"
    />
  </BModalConfirm>
</template>

<script>
import BAteTreeParticipantsImportModal from '@/components/forms/BAteTree/BAteTreeParticipantsImportModal.vue'
import { Adapter } from '@/store/createCrudModule'
import { MunMehApi } from '@/api/resources'

export default {
  name: 'PublicationMunMehImportModal',
  extends: BAteTreeParticipantsImportModal,
  titleText: 'Импорт данных',
  successText: 'Информация по мероприятию загружается. После завершения процесса вы получите сообщение в разделе уведомления',
  props: {
    munMehId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    list: [],
    isLoading: false,
    oFile: null,
    selected: null,
    fileTemplateUrl: '/files/mun_meh_import.csv',
  }),
  created() {
    const api = new MunMehApi()
    this.adapter = new Adapter(api)

    this.onGetData()
  },
  methods: {
    async onGetData() {
      this.isLoading = true
      try {
        const { data } = await this.adapter.api.getAll()
        this.list = data
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoading = false
    },
    async onSubmit() {
      const { oFile: file, selected } = this
      if (!file && !selected) throw new Error('Необходимо выбрать МунМех и/или файл')
      const payload = {}
      if (file) {
        payload.file = file
      }
      if (selected) {
        payload.munmeh_to_copy = selected
      }
      const api = new MunMehApi()
      await api.parseFormdata(this.munMehId, payload, {})
    },
  },
}
</script>
